<template>
  <div
    class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
  >
    <div
      class="box-border md:w-[400px] w-[90%] bg-white p-6 rounded-lg relative !z-999"
    >
      <button
        @click="closeForm"
        class="absolute top-0 right-0 -mt-4 -mr-4 p-2 bg-gray-200 rounded-full hover:bg-gray-300 focus:outline-none"
      >
        <svg
          class="w-6 h-6 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
      <div>
        <h3 class="text-center text-black text-[24px] pb-4 font-medium">
          Download Brochure
        </h3>
      </div>
      <form @submit.prevent="enquireSubmit">
        <div class="flex flex-col gap-4">
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 focus-within:border-blue-500"
          >
            <input
              type="text"
              name="name"
              id="Name"
              autocomplete="off"
              class="form-control widget_input w-full border-none focus:outline-none focus:ring-0"
              maxlength="255"
              minlength="1"
              placeholder="Enter Name (as per 10th Mark sheet) *"
              value=""
              required
              v-on:input="validateInput"
            />
          </div>
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 focus-within:border-blue-500"
          >
            <input
              class="w-full border-none focus:outline-none focus:ring-0"
              type="email"
              name="Email"
              id="Email"
              autocomplete="off"
              maxlength="50"
              placeholder="Enter Email Address *"
              value=""
              required
            />
          </div>
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 focus-within:border-blue-500"
          >
            <div class="flex">
              <select
                id="city_code"
                v-model="selectedCountryCode"
                @change="handleChange"
                class="form-control widget_input w-20 h-7 bg-gray-200 text-center"
              >
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    selectedCountryCode === country.code
                      ? selectedCountryCode
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                name="mobile"
                id="Mobile"
                autocomplete="off"
                maxlength="10"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 pl-2"
                pattern="[0-9]*"
                placeholder="Mobile *"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                v-model="mobileNumber"
                value=""
                required
              />
            </div>
          </div>
          <div
            class="box-border text-[14px] leading-normal text-[#333] text-center p-1"
          >
            <button
              type="submit"
              class="form-control widget_input w-full bg-[#001C54] hover:bg-[#F8C300] font-bold text-[16px] text-white p-2 rounded-md"
            >
              Download Brochure
            </button>
          </div>
        </div>
      </form>
      <div>
        <span
          v-if="submissionStatus === 'error'"
          class="text-red-500 text-xs"
          >{{ errorMessage }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import countryCodeMixins from "@/mixins/countryCodeMixins";
export default {
  name: "BrochureView",
  mixins: [countryCodeMixins],
  data() {
    return {
      name: "",
      mobileNumber: "",
      // errorStatus: false,
      errorMessage: "",
      selectedCountryCode: "+91",
      submissionStatus: "",
    };
  },
  methods: {
    closeForm() {
      this.$emit("close-button");
    },
    enquireSubmit(el) {
      let dataJson = {
        name: el.target.elements.Name.value,
        email: el.target.elements.Email.value,
        phone: `${this.selectedCountryCode}${this.mobileNumber}`,
        university: "jain",
        utmCampaign: this.$route.query.utm_campaign || "Direct",
        utmSource: this.$route.query.utm_source || "Direct",
        utmMedium: this.$route.query.utm_medium || "Direct",
        utmPlacement: this.$route.query.utm_placement || "",
        utmAdgroupId: this.$route.query.utm_adgroupid || "",
        utmCreativeId: this.$route.query.utm_creativeid || "",
        utmDevice: this.$route.query.utm_device || "",
        utmNetwork: this.$route.query.utm_network || "",
        utmCampaignId: this.$route.query.utm_campaignid || "",
        utmMatchType: this.$route.query.utm_matchype || "",
        utmKeyword: this.$route.query.utm_keyword || "",
        utmChannel: "Overall Brochure" || "",
        utmURL: window.location.href || "",
      };

      var thatSelect = this;
      this.errorStatus = false;
      this.submissionStatus = "";
      console.log(dataJson);

      axios
        .post(`${process.env.VUE_APP_LEADAPI}/lead/`, dataJson)
        .then(async (resp) => {
          if (resp.data.lead.success === true) {
            el.target.reset();

            // Choose brochure URL based on route
            let brochureUrl = `https://onlinejain.com/pdf/2025/program/jo-overall-brochure.pdf`;
            if (this.$route.path === "/lp/online-mba") {
              brochureUrl = `https://onlinejain.com/pdf/2025/program/jo-program-brochure-mba-nov-19.pdf`;
            }

            axios
              .get(brochureUrl, {
                responseType: "blob",
              })
              .then((blobResp) => {
                const blob = new Blob([blobResp.data], {
                  type: "application/pdf",
                });
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.download =
                  this.$route.path === "/lp/online-mba"
                    ? `MBA-Brochure.pdf`
                    : `Overall-brochure.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(downloadUrl);
              });

            setTimeout(() => {
              thatSelect.selectedCountryCode = "+91";
              thatSelect.mobileNumber = "";
              thatSelect.closeForm();
            }, 2000);
          } else {
            if (
              resp.data.status === 500 &&
              resp.data.message === "Internal Server Error" &&
              resp.data.alert === "Error"
            ) {
              this.submissionStatus = "error";
              this.errorMessage = resp.data.message;
              console.log("Internal Server Error ::::", this.errorMessage);
            } else if (resp.data.status === 403) {
              if (
                resp.data.error.code === 400 &&
                resp.data.error.status === false &&
                resp.data.error.message === "Bad request"
              ) {
                this.submissionStatus = "error";
                this.errorMessage = resp.data.error.data
                  ? resp.data.error.data.error_list.common
                  : "";
              }
            } else {
              this.submissionStatus = "error";
              this.errorMessage = "Invalid Data";
            }
          }
        })
        .catch((err) => {
          this.submissionStatus = "error";
          console.log("error ", err);
          this.errorMessage = err;
        });
    },
    validateInput(event) {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(event.target.value)) {
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, "");
      }
      this.name = event.target.value;
    },
  },
};
</script>
<style></style>
